import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useEventStore, usePathStore, usePointStore } from "../../Store/store";

const OverlayContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.9);

  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  z-index: 1000;
  gap: 20px;
  div {
    display: flex;
    gap: 10px;
  }
  button {
    background-color: rgba(0, 255, 153, 0.1);
    color: #00ff99;
    border: 1px solid #00ff99;
    border-radius: 8px;
    padding: 10px 20px;
    cursor: pointer;
  }
`;

export default function Overlay() {
  const {
    selectionMode,
    resetSelectionMode,
    clearAllObstacles,
    obstacles,
    setObstacleModal,
  } = usePointStore();
  const { setObstacleMode } = usePathStore();
  const { cancelObstacle } = useEventStore();

  const { obstacleMode, overlayMessage, setShowOverlay } = usePathStore();

  const handleCompletePolygon = () => {
    if (obstacles.length >= 3) {
      setObstacleModal(true);
    } else {
      alert("최소 3개의 포인트가 필요합니다.");
    }
  };

  // 좌표 선택 모드 초기화 후 닫기
  const handleClose = () => {
    cancelObstacle();
    // 장애물 모드일 경우 장애물 좌표 초기화
    setShowOverlay(false);
    setObstacleMode(false);
  };

  return (
    <OverlayContainer>
      {overlayMessage}
      {obstacleMode && (
        <div
          style={{
            fontSize: "14px",
            color: "#b7b7b7",
          }}
        >
          시작점을 클릭하여 장애물 생성
        </div>
      )}
      <div>
        <button onClick={handleClose}>취소</button>
      </div>
    </OverlayContainer>
  );
}
